import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  PromotionsListParams,
  PromotionsListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const PROMOTIONS_LIST_QUERY_KEY = 'promotions_list';

export const usePromotionsListQuery = (
  url: string,
  queryParams: PromotionsListParams['queryParams'],
) =>
  useQuery({
    queryKey: [PROMOTIONS_LIST_QUERY_KEY, url, queryParams],
    queryFn: () =>
      HttpClient.request<PromotionsListResponseData>({
        method: 'GET',
        url,
        params: queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
